export const calendarDayFormatFrom = 'ddd DD, MMM YYYY'
export const calendarDayFormatTo = 'ddd DD MM'
